import React, { useEffect, useMemo, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { Link, useParams } from 'react-router-dom'
import fetchApi from '../../../api'
import Button from '../../../components/Button'
import Card, {
    CardBody,
    CardGrid,
    CardTitle,
} from '../../../components/Card.ui'
import { PageContentWrapperSection } from '../../../components/LayoutContainer.ui'
import Loading from '../../../components/Loading'
import TeamTitle from '../../../components/TeamTitle'
import { useUser } from '../../../data/user'
import NextEvent from '../../private/Team/components/NextEvent'
import PlayedMatch from '../../private/Team/components/PlayedMatch'
import { TeamMenuItem } from '../../private/Team/components/TeamMenuItem'
import ToggleMenu from '../../private/Team/components/ToggleMenu'

const PublicTeamDetailPage = () => {
    const { teamId } = useParams()
    const [isLoading, setIsLoading] = useState(true)
    const [teamDetails, setTeamDetail] = useState()
    const [nextMatch, setNextMatch] = useState()
    const [posts, setPosts] = useState()
    const [lastMatches, setLastMatches] = useState()
    const [selectedPlayedMatch, setSelectedPlayedMatch] = useState()
    const [{ activeUser, api }] = useUser()
    const isMobile = useMediaQuery({ query: '(max-width: 900px)' })
    useEffect(() => {
        fetchApi(`/teams/${teamId}`)
            .then((team) => {
                setTeamDetail(team)
            })
            .catch(console.error)
            .then(() => setIsLoading(false))
    }, [teamId])
    useEffect(() => {
        if (!teamDetails) return
        Promise.all([
            fetchApi(`/teams/${teamDetails._id}/events/upcoming-match`)
                .then((event) => {
                    setNextMatch(event)
                })
                .catch(console.error)
                .then(() => setIsLoading(false)),
            fetchApi(`/teams/${teamDetails._id}/posts`).then(setPosts),
            fetchApi(`/teams/${teamDetails._id}/events/form`).then((events) => {
                setLastMatches(events)
                setSelectedPlayedMatch(events[0])
            }),
        ])
    }, [teamDetails?._id]) // TODO: fetch the public data for team
    const isFollowing = useMemo(() => {
        if (!teamDetails) return
        console.log({ activeUser })
        return activeUser?.teamsFollowing?.some(
            ({ team }) => (team._id || team) === teamDetails?._id
        )
    }, [activeUser?.teamsFollowing, teamDetails?._id])
    if (isLoading) {
        return <Loading />
    }
    if (!teamDetails) {
        return <strong>Not found</strong>
    }

    return (
        <PageContentWrapperSection style={{ overflow: 'hidden' }}>
            <TeamTitle team={teamDetails} />
            {nextMatch && (
                <CardGrid
                    {...(isMobile
                        ? {
                              style: {
                                  display: 'flex',
                                  margin: 0,
                                  flexDirection: 'column',
                              },
                          }
                        : {})}
                >
                    <Card column="span 4">
                        <CardTitle>Next Match</CardTitle>
                        <CardBody background="var(--colors-grays-20)">
                            <NextEvent
                                event={nextMatch}
                                noLink
                                activeTeam={teamDetails}
                            />
                        </CardBody>
                    </Card>
                    <Card>
                        <CardTitle>Form</CardTitle>
                        <CardBody>
                            <ToggleMenu reversed>
                                {selectedPlayedMatch &&
                                    lastMatches?.map((match) => (
                                        <TeamMenuItem
                                            match={match}
                                            key={match._id}
                                            team={teamDetails}
                                            selectedPlayedMatch={
                                                selectedPlayedMatch
                                            }
                                            setSelectedPlayedMatch={
                                                setSelectedPlayedMatch
                                            }
                                        />
                                    ))}
                            </ToggleMenu>
                            {selectedPlayedMatch && (
                                <PlayedMatch
                                    noLink
                                    team={teamDetails}
                                    match={selectedPlayedMatch}
                                />
                            )}
                        </CardBody>
                    </Card>
                    {posts?.map(({ title, body, imageUrl, _id }) => (
                        <Card key={_id}>
                            <CardTitle>{title}</CardTitle>
                            <CardBody>
                                {imageUrl && (
                                    <img
                                        style={{ width: '100%' }}
                                        src={imageUrl}
                                    ></img>
                                )}
                                <p>{body}</p>
                            </CardBody>
                        </Card>
                    ))}
                </CardGrid>
            )}{' '}
            {isFollowing ? (
                <Link
                    style={{ margin: '0.5rem' }}
                    onClick={() => {
                        api.unfollowTeam(teamDetails._id)
                    }}
                >
                    Following {teamDetails?.name}, unfollow?
                </Link>
            ) : (
                <Button
                    style={{ margin: '0.5rem' }}
                    onClick={() => {
                        api.followTeam(teamDetails._id)
                    }}
                    disabled={!activeUser}
                >
                    ⭐ Follow {teamDetails.name} ⭐
                </Button>
            )}
            {!activeUser && (
                <small>
                    You can only follow {teamDetails.name} after{' '}
                    <Link to="/signup" style={{ textDecoration: 'underline' }}>
                        {' '}
                        signing up
                    </Link>{' '}
                    or
                    <Link to="/login" style={{ textDecoration: 'underline' }}>
                        {' '}
                        logging in
                    </Link>
                </small>
            )}
        </PageContentWrapperSection>
    )
}

export default PublicTeamDetailPage
